import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import * as Sentry from '@sentry/angular';
import { LOG_LEVEL } from '../models/general';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler({
    showDialog: false,
  });

  constructor(private logger: LoggerService) {}

  handleError(error: any): void {
    const defaultMessage = 'Unknown error';

    this.logger.log(error?.message || defaultMessage, LOG_LEVEL.ERROR);

    this.sentryHandler.handleError(error);
  }
}
